<script setup>
import {Swipe, SwipeItem} from "vant";
import {getJson} from "@/api/common";
import {onMounted, reactive, ref} from "vue";
import LeftLightning from "@/components/NewPC/LeftLightning.vue";
import RightLightning from "@/components/NewPC/RightLightning.vue";
import GiftEntry from "@/components/NewPC/GiftEntry.vue";
import CustomVideo from "@/components/NewPC/CustomVideo.vue";

const CustomVideoRef = ref(null);
const PlayerSwipeRef = ref(null);
const playerList = ref([]);
const swipeIndex = ref(0);

const images = reactive({
  icon_1: require("@/assets/newPc/player/icon_1.png"),
  icon_2: require("@/assets/newPc/player/icon_2.png"),
  icon_3: require("@/assets/newPc/player/icon_3.png"),
  icon_4: require("@/assets/newPc/player/icon_4.png"),
  icon_5: require("@/assets/newPc/player/icon_5.png"),
  icon_6: require("@/assets/newPc/player/icon_6.png"),
  icon_7: require("@/assets/newPc/player/icon_7.png"),
  icon_8: require("@/assets/newPc/player/icon_8.png"),
  cover_active_1: require("@/assets/newPc/player/cover_active_1.png"),
  cover_active_2: require("@/assets/newPc/player/cover_active_2.png"),
  cover_active_3: require("@/assets/newPc/player/cover_active_3.png"),
  cover_active_4: require("@/assets/newPc/player/cover_active_4.png"),
  cover_active_5: require("@/assets/newPc/player/cover_active_5.png"),
  cover_active_6: require("@/assets/newPc/player/cover_active_6.png"),
  cover_active_7: require("@/assets/newPc/player/cover_active_7.png"),
  cover_active_8: require("@/assets/newPc/player/cover_active_8.png"),
  cover_1: require("@/assets/newPc/player/cover_1.png"),
  cover_2: require("@/assets/newPc/player/cover_2.png"),
  cover_3: require("@/assets/newPc/player/cover_3.png"),
  cover_4: require("@/assets/newPc/player/cover_4.png"),
  cover_5: require("@/assets/newPc/player/cover_5.png"),
  cover_6: require("@/assets/newPc/player/cover_6.png"),
  cover_7: require("@/assets/newPc/player/cover_7.png"),
  cover_8: require("@/assets/newPc/player/cover_8.png"),
  radar_1: require("@/assets/newPc/player/radar_1.png"),
  radar_2: require("@/assets/newPc/player/radar_2.png"),
  radar_3: require("@/assets/newPc/player/radar_3.png"),
  radar_4: require("@/assets/newPc/player/radar_4.png"),
  radar_5: require("@/assets/newPc/player/radar_5.png"),
  radar_6: require("@/assets/newPc/player/radar_6.png"),
  radar_7: require("@/assets/newPc/player/radar_7.png"),
  radar_8: require("@/assets/newPc/player/radar_8.png"),
  pf: require('@/assets/newPc/player/pf.png'),
  c: require('@/assets/newPc/player/c.png'),
  pg: require('@/assets/newPc/player/pg.png'),
  sf: require('@/assets/newPc/player/sf.png'),
  sg: require('@/assets/newPc/player/sg.png'),
})

const getImage = (name) => {
  console.log('images[name]:', images[name]);
  return images[name];
}

const swipeChange = index => {
  swipeIndex.value = index;
}
const playerPageChange = (item, type) => {
  if (type == 'next') {
    item.next();
  } else {
    item.prev();
  }
}
const playerSwipeChange = (item, index) => {
  if (index == swipeIndex.value) return;
  item.swipeTo(index)
}


const handlePlay = (url) => {
  CustomVideoRef.value?.open(url);
}

onMounted(() => {
  getJson().then(result => {
    if (result.status == 200 && result.data.code == 0) {
      playerList.value = result.data.data.news.player;
    }
  })
})
</script>

<template>
<div class="screen">

  <swipe class="screen_swipe" ref="PlayerSwipeRef" :show-indicators="false" @change="swipeChange">
    <swipe-item class="screen_swipe_item" v-for="item of playerList">
      <img class="swipe_item_bg" :src="getImage(item.icon)" alt="">
      <div class="swipe_content">
        <div class="name">{{ item.name }}</div>
        <div class="tags">
          <div>{{ item.tag }}</div>
          <img :src="getImage(item.tagIcon)" alt="">
        </div>
        <div class="player_other">
          <div>身高：{{item.height}}</div>
          <div>体重：{{item.heavy}}</div>
        </div>
        <div class="skill">
          <img class="skill_1" :src="getImage(item.radar)" alt="">
          <img class="skill_2" @click="handlePlay(item.video)" src="@/assets/newPc/player/skill_2.png" alt="">
        </div>
      </div>
    </swipe-item>
  </swipe>

  <img class="swipe_left_icon" @click="playerPageChange(PlayerSwipeRef, 'prev')" src="@/assets/newPc/player/swipe_left_icon.png"  alt="">
  <img class="swipe_right_icon" @click="playerPageChange(PlayerSwipeRef, 'next')" src="@/assets/newPc/player/swipe_right_icon.png" alt="">

  <div class="swipe_dots">
    <div class="cover_block" v-for="(item, index) of playerList">
      <img :class="{'active': swipeIndex == index}"  @click="playerSwipeChange(PlayerSwipeRef, index)" :src="getImage(swipeIndex == index ? item.coverActive:item.cover)" alt="">
    </div>
  </div>
  
  <div class="tips_block">
    <text>下滑浏览 领福利</text>
    <img src="@/assets/newPc/more_icon_2.png" alt="">
  </div>


  <left-lightning class="left_lightning" />
  <right-lightning class="right_lightning" />
  <custom-video ref="CustomVideoRef" />

</div>
</template>

<style scoped lang="scss">
.screen {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to right , #b5cfff, #e6efff);
  position: relative;

  .swipe_left_icon, .swipe_right_icon {
    width: 3.1640625vw;
    height: 4.8046875vw;
    position: absolute;
    top: 19.140625vw;
    cursor: pointer;
    z-index: 2;
  }
  .swipe_left_icon {
    left: 12.2265625vw;
  }
  .swipe_right_icon {
    right: 12.2265625vw;
  }

  .swipe_dots {
    position: absolute;
    top: 36.09375vw;
    right: 0;
    width: 73.59375vw;
    height: 5.2734375vw;
    background-color: transparent;
    z-index: 1;
    display: flex;
    flex-direction: row;
    padding-left: 3.90625vw;
    box-sizing: border-box;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 2.36328125vw;
      display: block;
      width: 0.546875vw;
      height: 0.546875vw;
      background: #fff;
      border-radius: 50%;
    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      right: 0;
      display: block;
      height: 0.078125vw;
      background: #fff;
      z-index: -1;
    }

    .cover_block {
      width: 4.921875vw;
      height: 5.2734375vw;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 2.265625vw;


      img {
        width: 3.9453125vw;
        height: 3.9453125vw;
        cursor: pointer;

        &.active {
          width: 4.921875vw;
          height: 5.2734375vw;
        }
      }
    }
  }

  .screen_swipe {
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 1;

    .screen_swipe_item {
      width: 100vw;
      height: 100vh;
      cursor: default;
      position: relative;

      .swipe_content {
        width: 37.9296875vw;
        height: 26.9140625vw;
        position: absolute;
        top: 8.0859375vw;
        left: 18.0078125vw;
        z-index: 9;
        background: transparent url("@/assets/newPc/player/swipe_content_bg.png") no-repeat center center;
        background-size: cover;
        padding: 1.453125vw 2.578125vw 0;
        box-sizing: border-box;

        .name {
          font-family: 'SourceHanSansCN-Bold';
          font-size: 3.90625vw;
          color: #fff;
          width: 12.3671875vw;
          text-align: center;
        }

        .tags {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 1.171875vw;
          div {
            width: 11.3671875vw;
            height: 1.5625vw;
            line-height: 1.5625vw;
            text-align: center;
            background: #fff;
            margin-right: 0.1953125vw;
            color: #7D8EAD;
            font-size: 0.78125vw;
          }
          img {
            width: 1.5625vw;
            height: 1.5625vw;
          }
        }

        .player_other {
          font-family: 'SourceHanSansCN-Regular';
          font-size: 0.78125vw;
          margin-bottom: 1.734375vw;
        }

        .skill {
          border-top: 0.0390625vw solid #fff;
          padding-top: 1vw;
          display: flex;
          flex-direction: row;
          align-items: flex-end;

          &_1 {
            width: 14.1796875vw;
            height: 8.9453125vw;
          }

          &_2 {
            width: 13.046875vw;
            height: 6.953125vw;
            margin-left: 2.0703125vw;
            cursor: pointer;
          }
        }
      }


      .swipe_item_bg {
        width: 82.421875vw;
        height: auto;
      }
    }
  }


  .tips_block {
    position: absolute;
    top: 42.734375vw;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #4C6ACB;
    font-size: 0.9375vw;
    font-family: 'SourceHanSansCN-Medium';

    img {
      width: 2.6171875vw;
      height: 2.109375vw;
    }
  }

  .left_lightning {
    position: absolute;
    left: 0;
    top: 28.59375vw;
  }

  .right_lightning {
    position: absolute;
    right: 0;
    top: 8.671875vw;
  }
}
</style>